import { parseMedicineExcelData, removeDuplicates } from ".";
import { getAllSupplyOrderDocumentForExcelInvoice } from "../Backend/firebase/supply-bills";
import { getExtraMedicineForSupply } from "../Backend/firebase/supply-order";
import { parseSchemeMedicineExcelData } from "./schemes";

export const loadAllMedicine = async () => {
    const getExtraMedicine = await getExtraMedicineForSupply()
    const getLocalMedicineList = parseMedicineExcelData();
    const getLocalSchemeMedicineList = parseSchemeMedicineExcelData();
    const getExcelInvoiceMedicine = await getAllSupplyOrderDocumentForExcelInvoice();
    const combinedData = [...getExtraMedicine, ...getLocalMedicineList, ...getLocalSchemeMedicineList, ...getExcelInvoiceMedicine];
    const uniqueData = removeDuplicates(combinedData);
    return uniqueData;
};